import { BugetManagerFilter } from "../types";

export function bugetMapperPayloadMapper(data: BugetManagerFilter) {
  return {
    Range: data?.range,
    Actuals: data?.actuals,
    Period: data?.periods
  }
}